import React from "react";
import CButton from "./CButton";
import CDialog from "./CDialog";
import CloseIcon from "@mui/icons-material/Close";

/**
 * TrainingTypeCategoryMatrixDialog Component
 * 
 * A reusable dialog component that displays the Training Type Category Matrix
 * showing the mapping between categories (A-G) and their corresponding training types.
 * 
 * @param {boolean} open - Whether the dialog is open
 * @param {Function} onClose - Function to close the dialog
 */
const TrainingTypeCategoryMatrixDialog = ({ open, onClose }) => {
  return (
    <CDialog open={open} onClose={onClose}>
      <div className="p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-xl font-semibold text-gray-800">
            Training Type Category Matrix
          </h3>
          <CButton onClick={onClose} className="!h-auto !p-0 !min-w-0">
            <CloseIcon className="text-gray-700 hover:text-gray-900" sx={{ fontSize: 20 }} />
          </CButton>
        </div>
        <div className="border border-blue-200 rounded-lg overflow-hidden">
          <table className="w-full border-collapse text-sm">
            <thead>
              <tr>
                <th className="text-center py-3 px-4 bg-blue-50 border-b border-blue-200 font-semibold text-gray-800 w-[140px]">
                  Category
                </th>
                <th className="text-left py-3 px-4 bg-blue-50 border-b border-blue-200 font-semibold text-gray-800">
                  Description
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-blue-100">
                <td className="text-center py-3 px-4 font-medium text-gray-800">Category A</td>
                <td className="text-left py-3 px-4 text-gray-700">Bursary/Qualification</td>
              </tr>
              <tr className="border-b border-blue-100">
                <td className="text-center py-3 px-4 font-medium text-gray-800">Category B</td>
                <td className="text-left py-3 px-4 text-gray-700">Skills Programmes with workplace component</td>
              </tr>
              <tr className="border-b border-blue-100">
                <td className="text-center py-3 px-4 font-medium text-gray-800">Category C</td>
                <td className="text-left py-3 px-4 text-gray-700">Internships (unemployed learners)</td>
              </tr>
              <tr className="border-b border-blue-100">
                <td className="text-center py-3 px-4 font-medium text-gray-800">Category D</td>
                <td className="text-left py-3 px-4 text-gray-700">Learnerships</td>
              </tr>
              <tr className="border-b border-blue-100">
                <td className="text-center py-3 px-4 font-medium text-gray-800">Category E</td>
                <td className="text-left py-3 px-4 text-gray-700">Short Courses/compliance training</td>
              </tr>
              <tr className="border-b border-blue-100">
                <td className="text-center py-3 px-4 font-medium text-gray-800">Category F</td>
                <td className="text-left py-3 px-4 text-gray-700">Workshops/Seminars/CPDs</td>
              </tr>
              <tr className="border-b border-blue-100">
                <td className="text-center py-3 px-4 font-medium text-gray-800">Category G</td>
                <td className="text-left py-3 px-4 text-gray-700">Inhouse Training (SOP training, etc)</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </CDialog>
  );
};

export default TrainingTypeCategoryMatrixDialog;
